import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-rezultati-add-dialog',
  templateUrl: './rezultati-add-dialog.component.html',
  styleUrls: ['./rezultati-add-dialog.component.scss']
})
export class RezultatiAddDialogComponent implements OnInit {
  @Input() target: any = {
    targetID: null,
    member_id: '',
    competitionId: '',
    category_id: ''
  };

  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  competitions: any[] = [];
  members: any[] = [];
  categories: any[] = [];
  clubs: any[] = [];
  teamNames: string[] = [];
  readonly teamNumbers = [1, 2, 3];
  memberSearch: string = '';
  clubSearch = '';
  selectedTeamNumber: number | null = null;
  
  // Member combobox properties
  showMemberDropdown: boolean = false;
  selectedMember: any = null;
  showClubDropdown = false;
  selectedClub: any = null;
  
  // Competition combobox properties
  showCompetitionDropdown: boolean = false;
  selectedCompetition: any = null;
  competitionSearch: string = '';
  
  // Category combobox properties
  showCategoryDropdown: boolean = false;
  selectedCategory: any = null;
  categorySearch: string = '';
  teamNumberError = '';

  get teamClubName(): string {
    return this.selectedMember?.name || this.target?.club_name || 'Izberite strelca';
  }

  get teamCategoryName(): string {
    return this.selectedCategory?.category_name || this.target?.category_name || 'Izberite kategorijo';
  }

  get teamSelectionReady(): boolean {
    return !!this.selectedMember && !!this.selectedCategory;
  }

  constructor(private http: HttpClient) {}

  ngOnInit() {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    // Load competitions
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/competitions', { headers, params }).subscribe(
      data => this.competitions = data,
      err => this.competitions = []
    );
    // Load categories
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/categories', { headers, params }).subscribe(
      data => {
        this.categories = Array.isArray(data) ? data : [];
        this.initializeSelectedValues();
      },
      err => this.categories = []
    );
    // Load all members initially for combobox
    this.loadClubs();
    this.searchMembers();
    this.loadTeamNames();
    this.initializeSelectedValues();
  }

  private loadClubs(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/clubs', { headers, params }).subscribe({
      next: clubs => {
        this.clubs = Array.isArray(clubs) ? clubs : [];
        this.initializeSelectedClub();
      },
      error: error => {
        console.error('Error fetching clubs:', error);
        this.clubs = [];
      }
    });
  }

  private initializeSelectedClub(): void {
    if (this.target?.club_id === null || this.target?.club_id === undefined || this.target.club_id === '') return;
    this.selectedClub = this.clubs.find(club => String(club.club_id) === String(this.target.club_id)) || {
      club_id: this.target.club_id,
      name: this.target.club_name
    };
    this.clubSearch = this.selectedClub.name || String(this.selectedClub.club_id);
  }

  private loadTeamNames(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;
    this.http.get<string[]>('https://testapi.ovh/api/strelstvo/team-names', { headers, params }).subscribe({
      next: names => this.teamNames = Array.isArray(names) ? names : [],
      error: () => this.teamNames = []
    });
  }

  private initializeSelectedValues(): void {
    if (this.target?.teams_number !== null && this.target?.teams_number !== undefined && this.target.teams_number !== '') {
      const teamNumber = Number(this.target.teams_number);
      this.selectedTeamNumber = this.teamNumbers.includes(teamNumber) ? teamNumber : null;
    }
    if (this.target?.member_id !== null && this.target?.member_id !== undefined && this.target.member_id !== '') {
      this.selectedMember = { member_id: this.target.member_id, full_name: this.target.member_full_name };
      this.memberSearch = this.target.member_full_name || String(this.target.member_id);
    }
    if (this.target?.competitionId !== null && this.target?.competitionId !== undefined && this.target.competitionId !== '') {
      this.selectedCompetition = { competitionId: this.target.competitionId, competition_name: this.target.competition_name };
      this.competitionSearch = this.target.competition_name || String(this.target.competitionId);
    }
    if (this.target?.category_id !== null && this.target?.category_id !== undefined && this.target.category_id !== '') {
      this.selectedCategory = this.categories.find(category =>
        String(category.category_id) === String(this.target.category_id)
      ) || { category_id: this.target.category_id, category_name: this.target.category_name };
      this.categorySearch = this.selectedCategory.category_name || String(this.target.category_id);
    }
  }

  onSave() {
    this.teamNumberError = '';
    console.log('onSave called with target:', this.target);
    console.log('targetID type:', typeof this.target.targetID, 'value:', this.target.targetID);
    
    // Convert empty string to null or undefined
    let member_id = this.target.member_id;
    if (this.selectedMember?.member_id !== null && this.selectedMember?.member_id !== undefined) {
      member_id = this.selectedMember.member_id;
    } else if (this.memberSearch.trim()) {
      this.teamNumberError = 'Izberite strelca iz seznama zadetkov.';
      return;
    }
    if (member_id === '' || member_id === null || member_id === undefined) {
      member_id = null;
    } else {
      member_id = Number(member_id);
    }

    let competitionId = this.target.competitionId;
    if (competitionId === '' || competitionId === null || competitionId === undefined) {
      competitionId = null;
    } else {
      competitionId = Number(competitionId);
    }

    let category_id = this.target.category_id;
    if (category_id === '' || category_id === null || category_id === undefined) {
      category_id = null;
    } else {
      category_id = Number(category_id);
    }

    const teams_number = this.selectedTeamNumber;
    const team_name = this.selectedTeamNumber !== null
      ? null
      : String(this.target.team_name || '').trim() || null;

    const payload: any = {};
    if (member_id !== null) payload.member_id = member_id;
    const clubId = this.selectedClub?.club_id ?? this.selectedMember?.club_id;
    if (clubId !== null && clubId !== undefined) {
      payload.club_id = Number(clubId);
    }
    if (competitionId !== null) payload.competitionId = competitionId;
    if (category_id !== null) payload.category_id = category_id;
    payload.team_name = team_name;
    payload.teams_number = team_name ? null : teams_number;

    const apiUrl = `https://testapi.ovh/api/strelstvo/targets/${this.target.targetID}`;
    console.log('Saving target:', {
      targetID: this.target.targetID,
      payload,
      apiUrl
    });

    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.put(apiUrl, payload, { headers, params }).subscribe(
      (response) => {
        console.log('Save response:', response);
        this.save.emit(response);
      },
      (error) => {
        console.error('Error saving result:', error);
        if (error.status === 409) {
          this.teamNumberError = error.error?.error || 'Ta številka ekipe je v tem tekmovanju že zasedena.';
        } else if (error.status === 404) {
          alert('Napaka: Tarča ni najdena. Morda je bila izbrisana ali ID ni veljaven.');
        } else {
          alert('Napaka pri shranjevanju rezultata!');
        }
      }
    );
  }

  onCancel() {
    this.cancel.emit();
  }

  clearData() {
    const confirmed = window.confirm(
      'Želite odstraniti strelca, tekmovanje, kategorijo in ekipo s te tarče? Tega dejanja ni mogoče razveljaviti.'
    );
    if (!confirmed) {
      return;
    }

    console.log('clearData called with target:', this.target);
    console.log('targetID type:', typeof this.target.targetID, 'value:', this.target.targetID);
    
    // Set fields to null
    this.target.member_id = null;
    this.target.competitionId = null;
    this.target.category_id = null;
    this.target.teams_number = null;
    this.selectedTeamNumber = null;
    this.target.team_name = null;
    
    // Clear combobox search fields and selections
    this.memberSearch = '';
    this.clubSearch = '';
    this.competitionSearch = '';
    this.categorySearch = '';
    this.selectedMember = null;
    this.selectedClub = null;
    this.selectedCompetition = null;
    this.selectedCategory = null;

    // Send PUT request to clear data in DB
    const payload = {
      member_id: null,
      competitionId: null,
      category_id: null,
      teams_number: null,
      team_name: null
    };

    const apiUrl = `https://testapi.ovh/api/strelstvo/targets/${this.target.targetID}`;
    console.log('Clearing target data:', {
      targetID: this.target.targetID,
      payload,
      apiUrl
    });

    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.put(apiUrl, payload, { headers, params }).subscribe(
      (response) => {
        console.log('Clear response:', response);
        this.save.emit(response);
      },
      (error) => {
        console.error('Error clearing data:', error);
        if (error.status === 404) {
          alert('Napaka: Tarča ni najdena. Morda je bila izbrisana ali ID ni veljaven.');
        } else {
          alert('Napaka pri čiščenju podatkov!');
        }
      }
    );
  }

  searchMembers(search: string = '') {
    const params: any = {};
    if (search) {
      params.full_name = search;
      // If the search is a number, also search by member_id
      if (!isNaN(Number(search))) {
        params.member_id = search;
        params.full_name = '';
      }
    }
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const requestParams = unitId ? new HttpParams({ fromObject: { ...params, unit_id: unitId } }) : params;

    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/strelec', { params: requestParams, headers }).subscribe(
      data => {
        this.members = data;
      },
      err => {
        console.error('Error fetching members:', err);
        this.members = [];
      }
    );
  }

  getFilteredMembers(): any[] {
    const members = this.selectedClub
      ? this.members.filter(member => String(member.club_id) === String(this.selectedClub.club_id))
      : this.members;
    if (!this.memberSearch || this.memberSearch.trim() === '') return members;

    const searchTerm = this.memberSearch.toLowerCase().trim();
    return members.filter(member => {
      const memberId = member.member_id?.toString() || '';
      const fullName = member.full_name || '';
      
      return memberId.includes(searchTerm) || 
             fullName.toLowerCase().includes(searchTerm);
    });
  }

  getFilteredClubs(): any[] {
    if (!this.clubSearch || this.clubSearch.trim() === '') return this.clubs;
    const searchTerm = this.clubSearch.toLowerCase().trim();
    return this.clubs.filter(club =>
      String(club.club_id || '').includes(searchTerm) ||
      String(club.name || '').toLowerCase().includes(searchTerm) ||
      String(club.code || '').toLowerCase().includes(searchTerm)
    );
  }

  onClubSearchChange(): void {
    if (this.selectedClub && this.clubSearch !== (this.selectedClub.name || this.selectedClub.club_id?.toString())) {
      this.selectedClub = null;
      this.selectedMember = null;
      this.memberSearch = '';
      this.target.member_id = '';
      this.selectedTeamNumber = null;
      this.target.teams_number = null;
    }
  }

  onClubBlur(): void {
    setTimeout(() => this.showClubDropdown = false, 200);
  }

  selectClub(club: any): void {
    this.selectedClub = club;
    this.clubSearch = club.name || club.club_id?.toString();
    this.selectedMember = null;
    this.memberSearch = '';
    this.target.member_id = '';
    this.selectedTeamNumber = null;
    this.target.teams_number = null;
    this.showClubDropdown = false;
  }

  onMemberSearchChange(): void {
    // Clear selected member if the search text doesn't match the selected member's name
    if (this.selectedMember && this.memberSearch !== (this.selectedMember.full_name || this.selectedMember.member_id?.toString())) {
      this.selectedMember = null;
      this.target.member_id = '';
    }
  }

  onMemberBlur(): void {
    setTimeout(() => this.showMemberDropdown = false, 200);
  }

  selectMember(member: any): void {
    this.selectedMember = member;
    this.memberSearch = member.full_name || member.member_id?.toString();
    this.target.member_id = member.member_id;
    this.showMemberDropdown = false;
  }

  getFilteredCompetitions(): any[] {
    if (!this.competitionSearch || this.competitionSearch.trim() === '') {
      return this.competitions;
    }
    
    const searchTerm = this.competitionSearch.toLowerCase().trim();
    return this.competitions.filter(competition => {
      const compId = competition.competitionId?.toString() || '';
      const compName = competition.competition_name || '';
      
      return compId.includes(searchTerm) || 
             compName.toLowerCase().includes(searchTerm);
    });
  }

  onCompetitionSearchChange(): void {
    if (this.selectedCompetition && this.competitionSearch !== (this.selectedCompetition.competition_name || this.selectedCompetition.competitionId?.toString())) {
      this.selectedCompetition = null;
      this.target.competitionId = '';
    }
  }

  onCompetitionBlur(): void {
    setTimeout(() => this.showCompetitionDropdown = false, 200);
  }

  selectCompetition(competition: any): void {
    this.selectedCompetition = competition;
    this.competitionSearch = competition.competition_name || competition.competitionId?.toString();
    this.target.competitionId = competition.competitionId;
    this.showCompetitionDropdown = false;
  }

  getFilteredCategories(): any[] {
    if (!this.categorySearch || this.categorySearch.trim() === '') {
      return this.categories;
    }
    
    const searchTerm = this.categorySearch.toLowerCase().trim();
    return this.categories.filter(category => {
      const catId = category.category_id?.toString() || '';
      const catName = category.category_name || '';
      
      return catId.includes(searchTerm) || 
             catName.toLowerCase().includes(searchTerm);
    });
  }

  onCategorySearchChange(): void {
    if (this.selectedCategory && this.categorySearch !== (this.selectedCategory.category_name || this.selectedCategory.category_id?.toString())) {
      this.selectedCategory = null;
      this.target.category_id = '';
    }
  }

  onCategoryBlur(): void {
    setTimeout(() => this.showCategoryDropdown = false, 200);
  }

  selectCategory(category: any): void {
    this.selectedCategory = category;
    this.categorySearch = category.category_name || category.category_id?.toString();
    this.target.category_id = category.category_id;
    this.showCategoryDropdown = false;
  }

  clearTeamNumber(): void {
    this.target.teams_number = null;
    this.selectedTeamNumber = null;
  }
}